import { LeadCard } from "./LeadCard";
import { Link } from "react-router-dom";
import LeadShimmerEffect from "./LeadShimmerEffect";
import { encodeURIComponent } from "@lib/utils";
import { useDynamicHeight } from "@customHooks/useDynamicHeight";
import { useIsMobile } from "@customHooks/use-mobile";
import { ListShimmer } from "./LeadCardShimmer";
import { Lead } from "../types";

export const LeadsListV2 = ({ searchQuery, isLoading, filteredLeads }: { searchQuery: string, isLoading: boolean, filteredLeads: Lead[] }) => {
  const { ref, height } = useDynamicHeight();
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <div className="mt-3">
        {isMobile ? (
          <div>
            <ListShimmer />
          </div>
        ) : (
          <LeadShimmerEffect />
        )}
      </div>
    );
  }

  return (
    <div
      className="flex flex-col gap-1 flex-1 mt-3 overflow-auto"
      ref={ref}
      style={{
        maxHeight: `${height}px`,
      }}
    >
      {filteredLeads.length ? (
        filteredLeads.map(
          ({ firstName, lastName, phoneNumber, email, source }, index) => (
            <Link
              to={`/dashboard/lead-details/${encodeURIComponent(phoneNumber)}`}
              key={index}
            >
              <LeadCard
                firstName={firstName}
                lastName={lastName}
                mobileNumber={phoneNumber}
                emailAddress={email}
                index={index}
                source={source}
              />
            </Link>
          )
        )
      ) : (
        <p className="text-center text-gray-500 p-10">
          No leads found for the search query {searchQuery}.
        </p>
      )}
    </div>
  );
};
